<template>
  <div class="container">
    <el-container>
      <!-- 头部区域 -->
      <el-header>
        <!-- <head-bar></head-bar> -->
        <head-bar-2></head-bar-2>
      </el-header>
      <el-container>
        <!-- 导航菜单栏  -->
        <el-aside width="200px">
          <nav-bar></nav-bar>
        </el-aside>
        <!-- 主内容区域 -->
        <el-main>
          <main-content></main-content>
        </el-main>
      </el-container>
    </el-container>
    <float-icon></float-icon>
  </div>
</template>

<script>
import HeadBar from "@/views/Layout/HeadBar";
import HeadBar2 from "@/views/Layout/HeadBar2";
import NavBar from "@/views/Layout/NavBar";
import MainContent from "@/views/Layout/MainContent";
import FloatIcon from "@/views/Core/FloatIcon";
import UfFooter from "@/views/Layout/UfFooter";
import SideToolBar from "@/views/Core/SideToolBar";
export default {
  name: "Home",
  components: {
    HeadBar,
    HeadBar2,
    NavBar,
    MainContent,
    FloatIcon,
    UfFooter,
    SideToolBar
  }
};
</script>

<style lang="scss" scoped>
.container {
  position: absolute;
  margin: 0 auto;
  padding: 0;
  top: 0px;
  left: 0px;
  right: 0px;
  bottom: 0px;
  width: 100%;
  min-width: 1200px;
  //background: rgba(224, 234, 235, 0.1);
  //background: rgb(236, 236, 236);
  //background: #bfbfbf;
  // background: rgb(222, 222, 222);
  .el-header {
    padding: 0 0;
  }
  .el-footer {
    background-color: #ffffff;
    color: #333;
    font-size: 14px;
    text-align: center;
    line-height: 1.5em;
    .copyright {
      top: 0px;
      margin-top: 0px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/Home.vue